import { Box, Button, Typography, IconButton } from '@mui/material';
import { X, Warning } from '@phosphor-icons/react';
import useStyles from '../Breakdown.style';
import { toast } from 'react-hot-toast';
import { deleteArtifact } from '../../../../Services/artificatServices/artificatServices';

interface DeleteArtifactProps {
    handleClose: () => void;
    artifactId: string;
    artifactName: string;
    onDeleteSuccess?: () => void;
}

export default function DeleteArtifact({ handleClose, artifactId, artifactName, onDeleteSuccess }: DeleteArtifactProps) {
    const classes = useStyles();

    const handleDelete = async () => {
        try {
            const res = await deleteArtifact(artifactId);
            if (res.status === 200 || res.status === 201) {
                toast.success('Artifact deleted successfully');
                onDeleteSuccess?.();
                handleClose();
            }
        } catch (error) {
            toast.error('Error deleting artifact');
            console.log(error);
        }
    };

    return (
        <Box className={classes.selectGenreRoot} sx={{ maxWidth: '400px !important' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography sx={{ fontSize: '18px', fontWeight: 500 }}>Delete Artifact</Typography>
                <IconButton onClick={handleClose} sx={{ color: '#606479', padding: '4px' }}>
                    <X size={24} />
                </IconButton>
            </Box>

            <Box sx={{ textAlign: 'center', py: 2 }}>
                <Warning size={48} color="#ff4444" weight="fill" />
                <Typography sx={{ fontSize: '14px', mt: 2, mb: 1 }}>
                    Are you sure you want to delete this artifact?
                </Typography>
                <Typography sx={{ fontSize: '16px', fontWeight: 500, color: '#6C65D9', mb: 1 }}>
                    "{artifactName}"
                </Typography>
                <Typography sx={{ fontSize: '12px', color: '#8D8E94' }}>
                    This action cannot be undone.
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 3 }}>
                <Button
                    onClick={handleClose}
                    sx={{
                        color: '#606479',
                        '&:hover': { backgroundColor: '#252A38' },
                        px: 3,
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleDelete}
                    sx={{
                        backgroundColor: '#ff4444',
                        color: 'white',
                        '&:hover': { backgroundColor: '#dd3333' },
                        px: 3,
                    }}
                >
                    Delete
                </Button>
            </Box>
        </Box>
    );
}
